import React from 'react';
import { Box } from '@mui/material';

interface TwDividerProps {
  className?: string;
}

const TwDivider: React.FC<TwDividerProps> = ({ className }): JSX.Element => {
  return (
    <Box
      className={className}
      sx={{
        height: '1px',
        backgroundColor: '#E5E7EB',
        width: '100%'
      }}
    />
  );
};

export default TwDivider;
